import { useIntl } from 'react-intl';
import { AsideMenuItem } from './AsideMenuItem';
import { useSelector } from 'react-redux';
import { authUserSelector } from '../../../../app/modules/auth';

export function AsideMenuErp() {
  const intl = useIntl();
  const authUser = useSelector(authUserSelector);
  const allowedGroups = ['B2B', 'Operations'];
  const isAuthorizedUser = !!authUser?.groups?.find((aGroup) =>
    allowedGroups.includes(aGroup.name)
  );

  return isAuthorizedUser ? (
    <>
      <h5 className="menu-title text-light pb-4 mb-0 mt-2 ms-6">
        {intl.formatMessage({ id: 'menu.erp' })}
      </h5>
      <AsideMenuItem
        to={`/stock`}
        title={intl.formatMessage({ id: 'menu.stock' })}
        fontIcon="fa-warehouse"
      />
      <AsideMenuItem
        to={`/stock-transfers`}
        title={intl.formatMessage({ id: 'menu.stockTransfers' })}
        fontIcon="fa-exchange-alt"
      />
      <AsideMenuItem
        to="/picking-chain"
        title={intl.formatMessage({ id: 'menu.pickingChain' })}
        fontIcon="fa-link"
      />
      <div className="menu-item">
        <div className="menu-content">
          <div className="separator mx-1 my-4"></div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
}
